import React from 'react';

export const formatLineBreaks = (text, secondaryKey = '') => {
  const textArr = text.split('\n');

  if (textArr.length === 1) return <span key={secondaryKey + '-0'}>{text}</span>;

  return textArr.map((item, key) => (
    <span key={`${secondaryKey}-${key}`}>
      {item}
      <br />
    </span>
  ));
};
